import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly session cookie is set by backend on login/register/session.
// withCredentials makes the browser attach it automatically. We NEVER read it
// from JS (prevents XSS token theft) — hence no interceptor / no localStorage.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
